<script setup lang="ts">
const { locale } = useI18n()

let links = [
	{ to: '/', translation_key_label: 'home_page' },
	{ to: 'about-us', translation_key_label: 'about_us' },
	{ to: 'https://intercom-help.eu/carfree/pl', translation_key_label: 'faq', link: true, rel: 'nofollow', newTab: true },
	{ to: 'contact', translation_key_label: 'contact' },
	{ to: 'https://carfree.webflow.io/', translation_key_label: 'app', link: true, rel: 'nofollow', newTab: true },
	{ to: 'news-page', translation_key_label: 'news', showOnlyOnPL: true },
]

links = links.map((link) => {
	if (link.translation_key_label === 'faq') {
		return { ...link, to: `https://intercom-help.eu/carfree/${locale.value === 'en' ? 'en' : 'pl'}/` }
	}
	return link
})

const linksOffer = [
	{ to: 'cars', translation_key_label: 'cars' },
	{ to: 'short-term', translation_key_label: 'car_rental_for_days' },
	{ to: 'medium-term', translation_key_label: 'car_rental_for_month' },
	{ to: 'long-term', translation_key_label: 'car_rental_long_term' },
	{ to: 'bus-rental', translation_key_label: 'bus_rental' },
	{ to: 'delivery-bus-rental', translation_key_label: 'delivery_van_rental' },
	{ to: 'insurance-replacement', translation_key_label: 'insurance_replacement' },
	// { to: 'cars', translation_key_label: 'replacement_car' },
]
</script>

<template>
	<div class="links-and-app">
		<div>
			<h6 class="links-and-app__title">Carfree</h6>
			<GlobalFooterLinks :data="links" />
		</div>
		<div>
			<h6 class="links-and-app__title">{{ $t('components.footer.links_and_app.title_offer') }}</h6>
			<GlobalFooterLinks :data="linksOffer" />
		</div>
		<div class="links-and-app__container">
			<p class="links-and-app__download-text">
				{{ $t('components.footer.links_and_app.download_our_app') }}:<br />{{ $t('components.footer.links_and_app.and_gain') }}
				<span class="links-and-app__download-text-discount">5% {{ $t('components.footer.links_and_app.discount') }}</span>
				{{ $t('components.footer.links_and_app.with_code') }}<br />
				<span class="links-and-app__download-text-discount">"START5"</span>
				{{ $t('components.footer.links_and_app.for_first_rent') }}
			</p>
			<div class="links-and-app__download">
				<NuxtLink style="position: relative; z-index: 10" to="https://www.apple.com/pl/app-store/" rel="nofollow" target="_blank">
					<GlobalImage style="height: 32px; width: auto" src="app-store-x2.png" alt="app store" :height="80" />
				</NuxtLink>
				<NuxtLink style="position: relative; z-index: 10" to="https://play.google.com/store/apps" rel="nofollow" target="_blank">
					<GlobalImage style="height: 32px; width: auto" src="google-play-x2.png" alt="google play" :height="80" />
				</NuxtLink>
			</div>
			<GlobalImage class="links-and-app__image links-and-app__image--1" alt="footer-phone-1" src="footer-phone-1.png" :height="206" />
			<GlobalImage class="links-and-app__image links-and-app__image--2" alt="footer-phone-2" src="footer-phone-2.png" :height="170" />
			<GlobalImage
				class="links-and-app__image links-and-app__image--mobile"
				alt="footer-phone-mobile"
				src="footer-phone-mobile.png"
				:height="206" />
		</div>
	</div>
</template>

<style scoped lang="scss">
@import './LinksAndApp';
</style>
